/**
 * Tenant `fontFamily` may list several Google Fonts, comma-separated
 * (e.g. "Montserrat, Alexandria" = Latin + Arabic). Browsers pick per glyph.
 */
export function parseFontFamilies(value: string | null | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map((f) => f.trim().replace(/^['"]|['"]$/g, ''))
    .filter(Boolean);
}

export function fontStack(value: string, fallback: string): string {
  const families = parseFontFamilies(value).map((f) => `'${f}'`);
  return [...families, fallback].join(', ');
}

const loaded = new Set<string>();

export function loadGoogleFonts(doc: Document, value: string): void {
  for (const family of parseFontFamilies(value)) {
    if (loaded.has(family)) continue;
    loaded.add(family);
    const link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@300;400;500;600;700&display=swap`;
    doc.head.appendChild(link);
  }
}
